import type { IconData } from '@stacksjs/iconify-core'

export const earth1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3\"/><path d=\"M15.575 43a36.7 36.7 0 0 0 2.78-7.428c.223-.878.17-1.798-.198-2.627c-.809-1.816-2.64-5.046-5.796-6.204a3.7 3.7 0 0 0-.833-.19c-1.17-.141-4.605-.496-8.312-.322m36.89 10.951c-3.754-3.208-6.892-9.106-8.146-11.671a3.02 3.02 0 0 0-1.924-1.601l-2.412-.64c-2.676-.71-4.894-2.869-4.411-5.582c.104-.582.261-1.19.493-1.803c.577-1.527 2.04-2.465 3.617-2.911c2.786-.787 7.59-2.062 12.354-2.943\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default earth1
